import styles from './blog-not-found.module.css';

function NotFoundBlogs() {
  return (
    <div className={styles.notFound}>
      <h2 className={styles.notFound_title}>
        Sorry, no results were found. :(
      </h2>
      <p className={styles.notFound_text}>
        Looks like we can’t find what you’re searching for.
      </p>
    </div>
  );
}

export default NotFoundBlogs;
